import React, { useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import { init as initSentry, reactRouterV6BrowserTracingIntegration } from '@chilipiper/sentry'
import { init } from '@chilipiper/websocket-debugger'
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from 'react-router-dom'
import { environment, sentry } from '@chilipiper/config'
import { App } from './App'
import { initialize as initializeGoogleTagManager } from './utils/gtm'

if (environment.deploy !== 'staging' && environment.node !== 'test') {
  initSentry(
    sentry.chilicalDSN,
    {
      replaysOnErrorSampleRate: 1,
      replaysSessionSampleRate: 0,
      initialScope: scope => {
        scope.setTags({ appVersion: __APP_VERSION__ })
        return scope
      },
    },
    reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    })
  )
  initializeGoogleTagManager()
}

init()

const root = createRoot(document.getElementById('root') as HTMLElement)
// removed strict mode usage because of <FocusScope> behaviour from react-spectrum library used for popover
// https://github.com/adobe/react-spectrum/issues/3515
root.render(<App />)
